window.addEventListener('load', () => {
setSpace();
});

window.addEventListener('resize', () => {
    setSpace();
});

function setSpace() {
    const header = document.querySelector<HTMLElement>('header .header .content');

    if (header) {
        const halfSpace = ((window.innerWidth - header.getBoundingClientRect().width) / 2);
        document.body.style.setProperty("--container-space", String(halfSpace) + "px");
    }
}